module.exports = __webpack_public_path__ + "img/horn.499b2cf3.png";